import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { $api } from '../../../../helpers/api'
import axios from 'axios'

export const getAbout = createAsyncThunk('get about about data', async () => {
  try {
    const result = await $api.get(`/about`)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

export const updateAbout = createAsyncThunk('update about about data', async ({ data }) => {
  try {
    const result = await $api.put(`/about`, data)
    return result.data
  } catch (e) {
    if (axios.isAxiosError(e)) {
      return console.error(e.message)
    }
  }
})

const initialState = {
  data: undefined,
  isLoading: false,
  error: null,
}

export const aboutSlice = createSlice({
  name: 'about',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAbout.pending, state => {
        state.isLoading = true
        state.data = undefined
        state.error = null
      })
      .addCase(getAbout.fulfilled, (state, action) => {
        state.isLoading = false
        state.data = action.payload
        state.error = null
      })
      .addCase(getAbout.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.payload
        state.error = action.error.message
      })
  },
})

export const { actions: aboutActions } = aboutSlice
export const { reducer: aboutReducer } = aboutSlice
